<template>
  <div class="d-flex" id="wrapper">
    <div id="sidebar-wrapper">
      <ManagerSidebar
        v-if="getAccType === 'user' || getAccType === 'manager'"
        :toggler.sync="isToggled"
      />
      <UserNavigationSidebar v-if="getAccType === 'candidate'" :toggler.sync="isToggled" />
      <!-- Page Content -->
    </div>

    <div id="page-content-wrapper">
      <TopNavbar
        @toggled="toggleSidebarNav"
        :profile="getAccType === 'candidate' ? getUserProfile : getManagerUserProfile"
      />
      <Support />
    </div>

    <!-- End page-content-wrapper -->
  </div>
</template>

<script>
import { toggleSidebarNav } from '../mixins/toggleSidebarNav';

import TopNavbar from '@/components/Navigations/TopNavbar';
import ManagerSidebar from '@/components/Navigations/ManagerSidebar';
import UserNavigationSidebar from '@/components/Navigations/UserNavigationSidebar';
import Support from '@/components/Support/Support';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    ManagerSidebar,
    UserNavigationSidebar,
    TopNavbar,
    Support,
  },
  mixins: [toggleSidebarNav],
  data: () => ({
    isToggled: false,
  }),
  methods: {
    ...mapActions('managerStoreModule', ['retrieveManagerProfile', 'retrieveManagerUserProfile']),
    ...mapActions(['retrieveCandidateUserProfile']),
  },
  computed: {
    ...mapGetters('managerStoreModule', ['getManagerProfile', 'getManagerUserProfile']),
    ...mapGetters(['getAccType', 'getUserProfile']),
  },
  mounted() {
    if (this.getAccType === 'candidate') {
      this.retrieveCandidateUserProfile();
    } else {
      this.retrieveManagerUserProfile();
    }
  },
};
</script>
